/**
 * Initial application domain state
 *
 * @type {Object}
 */
const initialState = {
    serviceManager: null,
    currentLocation: null,
    previousLocation: null,
};

/**
 * Application reducer
 *
 * @param state
 * @param {FluxStandardAction} action
 * @returns {Object}
 */
const applicationReducer = (state = initialState, action) => {
    state = {
        ...initialState,
        ...state,
    };

    switch (action.type) {
        case '@@router/LOCATION_CHANGE': {
            state.previousLocation = state.currentLocation;
            state.currentLocation = action.payload?.location;
            break;
        }

        default:
        // no-op
    }
    return state;
};

export default applicationReducer;
